(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.StepTransition = (function() {
    function StepTransition(handler, to, fromNav) {
      this.setFsrIds = bind(this.setFsrIds, this);
      var SppHandler;
      debugLog('new StepTransition');
      this.to = to;
      this.fromNav = fromNav != null ? fromNav : false;
      this.skippedStepIDs = [];
      this.errors = [];
      SppHandler = App.loadClass('grower::handlers/placement/SppHandler');
      if (handler instanceof SppHandler) {
        this.sppHandler = handler;
        this.taffy = this.sppHandler.taffyObjects;
        this.loadToStep();
      } else {
        this.fromHandler = handler;
        this.sppHandler = this.fromHandler.parent;
        this.taffy = $.extend(this.fromHandler.taffyObjects, this.sppHandler.taffyObjects);
        this.from = this.fromHandler.num;
        this.forward = this.to > this.from;
        this.start();
      }
    }

    StepTransition.prototype.start = function() {
      this.fromHandler.updateFieldsAspects();
      this.checkSkipConditions();
      if (this.fromHandler.beforeLeave != null) {
        if (!this.handleResponse(this.fromHandler.beforeLeave())) {
          return;
        }
      }
      return this.autosave();
    };

    StepTransition.prototype.checkSkipConditions = function() {
      var highest_visited_step, i, len, ref, step;
      ref = this.taffy.steps().get();
      for (i = 0, len = ref.length; i < len; i++) {
        step = ref[i];
        highest_visited_step = this.sppHandler.getHighestVisitedStep();
        if (this.to > highest_visited_step) {
          highest_visited_step = this.to;
        }
        if ((typeof step.skipConditions === "function" ? step.skipConditions() : void 0) && step.step_order <= highest_visited_step) {
          step.skipped(true);
          this.skippedStepIDs.push(step.id);
          this.taffy.fieldsAspects({
            steps_id: step.id
          }).update({
            skip: true
          });
        } else {
          step.skipped(false);
          this.skippedStepIDs = this.skippedStepIDs.filter(function(id) {
            return id !== step.id;
          });
        }
      }
      return this.skipSteps();
    };

    StepTransition.prototype.skipSteps = function() {
      var toStep;
      toStep = this.taffy.steps({
        step_order: this.to
      }).first();
      if (toStep.skipped()) {
        if (!this.fromNav) {
          if (this.forward) {
            this.to += 1;
          } else {
            this.to -= 1;
          }
          return this.checkSkipConditions();
        }
      }
    };

    StepTransition.prototype.handleResponse = function(response) {
      var canStop, msg, ref;
      if (response == null) {
        return true;
      }
      if (typeof response === 'boolean') {
        response = {
          status: {
            type: response ? 'success' : 'error',
            msg: ''
          }
        };
      }
      if (response.status == null) {
        response = {
          view: response
        };
        return true;
      }
      this.response = response;
      canStop = ((ref = response.data) != null ? ref.force_stop : void 0) || (this.forward && (this.fromHandler.firstLoad || this.fromHandler.inputChanged));
      if (response.status.type === 'error') {
        msg = response.status.msg;
        if (msg) {
          this.errors.push(msg);
        }
        if (canStop) {
          this.end();
          return false;
        }
      }
      return true;
    };

    StepTransition.prototype.end = function() {
      var ref, ref1;
      this.displayErrors();
      if ((ref = this.fromHandler) != null) {
        ref.firstLoad = false;
      }
      if ((ref1 = this.fromHandler) != null) {
        ref1.inputChanged = false;
      }
      this.sppHandler.curTransition = null;
      return delete this.sppHandler.curTransition;
    };

    StepTransition.prototype.displayErrors = function() {
      var msg;
      msg = this.sppHandler.curStep.msg;
      if (this.errors.length) {
        return msg != null ? msg.message_writer('error', this.errors.join('<br/>')) : void 0;
      } else {
        return msg != null ? msg.message_writer('clear') : void 0;
      }
    };

    StepTransition.prototype.autosave = function() {
      var aspect, aspects, field, fieldAspects, fields, fieldsArr, i, j, k, l, len, len1, len2, len3, len4, m, postParams, ref, ref1, ref2, ref3, ref4, verbose;
      verbose = false;
      if (this.sppHandler.taffyObjects.steps({
        step_order: this.to
      }).first().widget_name === 'Seed_Options') {
        this.taffy.fieldsAspects({
          skip: true
        }).remove();
      }
      fields = this.taffy.fields({
        selected: true
      });
      ref = fields.get();
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        fieldAspects = this.taffy.fieldsAspects({
          fields_id: field.id
        });
        aspects = [];
        if (verbose) {
          ref1 = fieldAspects.get();
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            aspect = ref1[j];
            aspects.push({
              fid: aspect.fields_id,
              fname: aspect.field_name,
              aid: aspect.aspects_id,
              aname: aspect.aspect_name,
              v: aspect.value,
              oid: aspect.options_id,
              oname: aspect.option_name
            });
          }
        } else {
          ref2 = fieldAspects.get();
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            aspect = ref2[k];
            aspects.push({
              aid: aspect.aspects_id,
              v: aspect.value,
              oid: aspect.options_id
            });
          }
        }
        fields.filter({
          id: field.id
        }).update({
          aspects: aspects
        });
      }

      /*
      We need to re-initialize the reference to the taffy DB after updating
      it, or else the results may be somewhat non-deterministic and sometimes
      not include the aspects set in the current step.
      
      In technical terms, we are creating a new 'aspects' array for each
      field. When we call update each field object, we are setting its
      'aspects' property to reference the new array object instead of the old
      one. The point I can't explain is why sometimes it appears that the
      'fields' Taffy DB uses the new reference to the array and other times it
      does not. I suspect it may have something to do with Taffy updating its
      internal database asynchronously, and that's why it gets wonky.
      
      I literally spent days tracking down this bug, and it sucked. I know it
      looks kind of useless, but for the love of all that is good and holy,
      DO NOT REMOVE THIS LINE OF CODE!!!
      -SK
       */
      fields = this.taffy.fields({
        selected: true
      });
      fieldsArr = [];
      if (verbose) {
        ref3 = fields.get();
        for (l = 0, len3 = ref3.length; l < len3; l++) {
          field = ref3[l];
          fieldsArr.push({
            id: field.id,
            display_name: field.display_name,
            aspects: field.aspects
          });
        }
      } else {
        ref4 = fields.get();
        for (m = 0, len4 = ref4.length; m < len4; m++) {
          field = ref4[m];
          fieldsArr.push({
            id: field.id,
            aspects: field.aspects
          });
        }
      }
      postParams = {
        id: this.sppHandler.sppID,
        result_id: this.sppHandler.resultID,
        fields: fieldsArr,
        step_id: this.taffy.steps({
          step_order: this.from
        }).first().id,
        next_step_id: this.taffy.steps({
          step_order: this.to
        }).first().id,
        continue_if_error: !(this.forward && (this.fromHandler.firstLoad || this.fromHandler.inputChanged)),
        skipped_step_ids: this.skippedStepIDs
      };
      if (this.sppHandler.operators_id) {
        postParams.operators_id = this.sppHandler.operators_id;
      }
      if (this.fromHandler.msg.length !== 0) {
        this.fromHandler.msg.message_writer('info', 'Saving your responses...');
      }
      return $.post('backend/grower/placement/spp/autosave', JSON.stringify(postParams), (function(_this) {
        return function(response) {
          var ref5, ref6;
          if (((ref5 = response.data) != null ? ref5.set_fsr_ids : void 0) != null) {
            _this.setFsrIds((ref6 = response.data) != null ? ref6.set_fsr_ids : void 0);
          }
          if (!_this.handleResponse(response)) {
            return;
          }
          if (_this.fromHandler.inputChanged) {
            _this.sppHandler.inputChanged = true;
          }
          return _this.loadToStep();
        };
      })(this)).fail((function(_this) {
        return function(error) {
          if (error.status === 404) {
            return _this.sppHandler.parent.refresh();
          }
        };
      })(this));
    };

    StepTransition.prototype.loadToStep = function() {
      var arr, func, name, ref, ref1, stepFuncs;
      this.toHandler = this.sppHandler.createSubHandler('step_' + this.to);
      if (this.toHandler == null) {
        return null;
      }
      this.sppHandler.curStep = this.toHandler;
      this.toHandler.response = this.response;
      if (((ref = this.response) != null ? ref.taffy : void 0) != null) {
        ref1 = this.response.taffy;
        for (name in ref1) {
          arr = ref1[name];
          this.toHandler.taffyObjects[name] = TAFFY(arr);
        }
      }
      stepFuncs = this.taffy.steps({
        step_order: this.to
      }).first();
      for (name in stepFuncs) {
        func = stepFuncs[name];
        if (name === 'afterEnter' || name === 'beforeLeave' || name === 'skipConditions') {
          this.toHandler[name] = func;
        }
      }
      this.toHandler.origAfterLoadLayout = this.toHandler.afterLoadLayout;
      this.toHandler.afterLoadLayout = (function(_this) {
        return function(sel, response) {
          var base, ref2;
          if (((ref2 = response.status) != null ? ref2.type : void 0) == null) {
            _this.end();
            return;
          }
          if (response != null ? response.data : void 0) {
            if ((base = _this.toHandler).data == null) {
              base.data = response.data;
            }
          }
          _this.toHandler.origAfterLoadLayout(sel, response);
          if (_this.toHandler.afterEnter != null) {
            if (!_this.handleResponse(_this.toHandler.afterEnter())) {
              return;
            }
          }
          return _this.end();
        };
      })(this);
      return this.toHandler.init();
    };

    StepTransition.prototype.setFsrIds = function(fsr_ids) {
      var field_id, fsr_id, results;
      results = [];
      for (field_id in fsr_ids) {
        fsr_id = fsr_ids[field_id];
        results.push(this.sppHandler.taffyObjects.fields({
          id: parseInt(field_id)
        }).update({
          fsr_id: fsr_id
        }));
      }
      return results;
    };

    return StepTransition;

  })();

}).call(this);
